import { render } from "./LoadingSkeletonCardButtom.vue?vue&type=template&id=cf192786&ts=true"
import script from "./LoadingSkeletonCardButtom.vue?vue&type=script&lang=ts"
export * from "./LoadingSkeletonCardButtom.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__